export let viewEmailFromNoteLabel = "RbrV4d";
export default {viewEmailFromNoteLabel};